import { render } from "./identifiersComponent.vue?vue&type=template&id=3ddffceb&scoped=true"
import script from "./identifiersComponent.vue?vue&type=script&lang=js"
export * from "./identifiersComponent.vue?vue&type=script&lang=js"

import "./identifiersComponent.vue?vue&type=style&index=0&id=3ddffceb&lang=scss&scoped=true"
import "./identifiersComponent.vue?vue&type=style&index=1&id=3ddffceb&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddffceb"]])

export default __exports__